export default class VerificationCodeInput extends Backbone.View {
    template({className, id, codeLength, label}) {
        let inputLabelBoxes = $('<div></div>');
        inputLabelBoxes.append('<div class="inputLabelBoxes"></div>');

        for (let i = 0; i < codeLength; i++) {
            inputLabelBoxes.find('.inputLabelBoxes').append(`
                <div class="inputLabelBox" style="width: ${this.boxWidthPercentage}%" id="${i}"><div>
            `);
        }

        return `
            <div class="verificationCodeInput ${className}" style="padding-top: ${this.containerHeightPercentage}%">
                <input id="${id}" type="tel" name="${id}" aria-label="${label}">
                ${inputLabelBoxes.html()}
            </div>`;
    }

    constructor({ className, id, codeLength, label }) {
        super(...arguments);

        _.extend(this, arguments[0]);

        this.codeLength = codeLength || 6;
    }

    render() {
        this.boxWidthPercentage = Math.floor(100 / this.codeLength - 1);
        this.containerHeightPercentage = Math.round(this.boxWidthPercentage * 4 / 3);

        this.$el.empty().append(this.template(this));

        this.$input = this.$el.find('input');

        this._attachEvents();

        return this;
    }

    _attachEvents() {
        this.$input.on('input change', () => {
            let inputCode = this.$input.val().replace(/\D/g, '');
            if (inputCode.length > this.codeLength) {
                inputCode = inputCode.slice(0, this.codeLength);
            }
            this.$input.val(inputCode);

            for (let i = 0; i <  this.codeLength; i++) {
                let box =  this.$el.find(`.inputLabelBox#${i}`);
                box.empty().append(`<div class="inputBoxContentWrapper"><span class="inputBoxContents">${inputCode.charAt(i)}</span></div>`);
                if (i < inputCode.length) {
                    box.removeClass('focused');
                }
                else if (i === inputCode.length) {
                    box.addClass('filled').addClass('focused');
                }
                else {
                    box.removeClass('filled').removeClass('focused');
                }
            }
            if (inputCode.length === this.codeLength) {
                this.$el.find(`.inputLabelBox#${inputCode.length - 1}`).addClass('focused');
            }
        });

        this.$el.find('.inputLabelBox').on('click', () => {
            this.$input.focus();
        });

        this.$input.on('focus', () => {
            let index = this.$input.val().length;
            if (index === this.codeLength) {
                index--;
            }
            this.$el.find(`.inputLabelBox#${index}`).addClass('focused').addClass('filled');
        });

        this.$input.on('blur', () => {
            let index = this.$input.val().length;
            if (index === this.codeLength) {
                this.$el.find(`.inputLabelBox#${index - 1}`).removeClass('focused');
            }
            else {
                this.$el.find(`.inputLabelBox#${index}`).removeClass('focused').removeClass('filled');
            }
        });
    }

    focus(){
        this.$input.focus();
    }

    validate() {
        if (this.$input.val().length === this.codeLength) {
            return true;
        }
        this.$el.find('.verificationCodeInput').addClass('invalid');
        this.$input.on('focus', () => {
            this.$el.find('.verificationCodeInput').removeClass('invalid');
        });
    }
}
